// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"c702f0f9","56":"9dd8d14d","654":"a1611b6a","758":"11e5431a","832":"1948fd59"}[chunkId] + ".chunk.js";
};